//Event archive
(function($) {
    "use strict";

    const $section_news_archive = $('.section-news-archive');

    if ($section_news_archive.length === 0) return;

    //manual ajax load-more
    $section_news_archive.on('click', 'a.load-more', function(e){
        //block the click action
        e.preventDefault();
        //remove the load-more button
        $(this).remove();
        //ajax get events
        $.ajax(
            $(this).attr('href'),
            {
                success: function(data) {
                    //find all events in response and append them to the results
                    $('.sf_results_row > *', data).appendTo($('.sf_results_row'));

                    //copy over the new load-more link, if it exists
                    $('.sf_results_pagination', data).appendTo($('.sf_results'));
                },
            }
        )
    });

})(jQuery);